import _ from 'lodash';
import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {PimsContainer} from './pims/PimsContainer';
import {PimsCntrEvent} from './PimsCntrEvent';
import { JobNames } from '../framework.core/JobNames';

export class MblStatusViewModel extends TrackableEntity {
    pimsLinkId: number = 0;
    mblNo: string = '';
    lPort: string = '';
    dPort: string = '';
    eta: string | null = null;
    fDest: string = '';
    vessel: string = '';
    frtLoc: string = '';
    pickUpNo: string = '';
    etd: string | null = null;
    firstCode: string = '';
    firstPort: string = '';
    firstCodeEta: string | null = null;
    storageDate: string | null = null;
    goDate: string | null = null;
    carrierName: string = '';
    opClosed: boolean = false;
    opCloseDate: string | null = null;
    closedBy: string = '';
    actClosed: boolean = false;
    actCloseDate: string | null = null;
    actClosedBy: string = '';
    commDocDate: string | null = null;
    commDocTime: string | null = null;
    commDocBy: string = '';
    commDocChk: boolean = false;
    entryDocDate: string | null = null;
    entryDocTime: string | null = null;
    entryDocBy: string = '';
    entryDocChk: boolean = false;
    f7501Date: string | null = null;
    f7501Time: string | null = null;
    f7501By: string = '';
    f7501Chk: boolean = false;
    f3461Date: string | null = null;
    f3461Time: string | null = null;
    f3461By: string = '';
    f3461Chk: boolean = false;
    puSentDate: string | null = null;
    puSentTime: string | null = null;
    puSentBy: string = '';
    puSentChk: boolean = false;
    delSchedDate: string | null = null;
    delSchedTime: string | null = null;
    delSchedBy: string = '';
    delSchedChk: boolean = false;
    delActDate: string | null = null;
    delActTime: string | null = null;
    delActBy: string = '';
    delActChk: boolean = false;
    podDate: string | null = null;
    podTime: string | null = null;
    podBy: string = '';
    podChk: boolean = false;
    billDate: string | null = null;
    billTime: string | null = null;
    billBy: string = '';
    billChk: boolean = false;
    billPacketDate: string | null = null;
    billPacketTime: string | null = null;
    billPacketBy: string = '';
    billPacketChk: boolean = false;
    trackerDate: string | null = null;
    trackerTime: string | null = null;
    trackerBy: string = '';
    trackerChk: boolean = false;
    lastTrackDate: string | null = null;
    lastTrackTime: string | null = null;
    lastTrackBy: string = '';
    lastTrackChk: boolean = false;
    emptyRetDate: string | null = null;
    emptyRetTime: string | null = null;
    emptyRetBy: string = '';
    emptyRetChk: boolean = false;
    anPrtDate: string | null = null;
    anPrtTime: string | null = null;
    anPrtBy: string = '';
    anPrtChk: boolean = false;
    inlandNtcDate: string | null = null;
    inlandNtcTime: string | null = null;
    inlandNtcBy: string = '';
    inlandNtcChk: boolean = false;
    doConfirmDate: string | null = null;
    doConfirmTime: string | null = null;
    doConfirmBy: string = '';
    doConfirmChk: boolean = false;
    doSentDate: string | null = null;
    doSentTime: string | null = null;
    doSentBy: string = '';
    doSentChk: boolean = false;
    delAddrDate: string | null = null;
    delAddrTime: string | null = null;
    delAddrBy: string = '';
    delAddrChk: boolean = false;
    ddpDate: string | null = null;
    ddpTime: string | null = null;
    ddpBy: string = '';
    ddpChk: boolean = false;
    examOnDate: string | null = null;
    examOnTime: string | null = null;
    examOnBy: string = '';
    examOnChk: boolean = false;
    examOffDate: string | null = null;
    examOffTime: string | null = null;
    examOffBy: string = '';
    examOffChk: boolean = false;
    anSend: string | null = null;
    anSendBy: string = '';
    isSend: boolean = false;
    atmeSend: string | null = null;
    atmeSendBy: string = '';
    isAtmeSend: boolean = false;
    cargoRls: string | null = null;
    cargoRlsBy: string = '';
    isCargoRls: boolean = false;
    anSentDate: string | null = null;
    anSentBy: string = '';
    anSentChk: boolean = false;
    fltNo: string = '';
    cargoOnBoard: string = '';
    cntrItemList: PimsContainer[] = [];
    eventItemList: PimsCntrEvent[] = [];

    constructor(init?:Partial<MblStatusViewModel>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
        this.noTrackProps.push('pimsLinkId', 'mblNo', 'lPort', 'dPort', 'eta', 'fDest', 'vessel', 'frtLoc', 'etd', 'firstCode', 'firstPort', 'firstCodeEta', 'storageDate', 'goDate', 'carrierName', 'opClosed', 'opCloseDate', 'closedBy', 'actClosed', 'actCloseDate', 'actClosedBy', 'commDocTime', 'entryDocTime', 'f7501Time', 'f3461Time', 'puSentTime', 'delSchedTime', 'delActTime', 'podTime', 'billTime', 'billPacketTime', 'trackerTime', 'lastTrackTime', 'emptyRetTime', 'anPrtTime', 'inlandNtcTime', 'doConfirmTime', 'doSentTime', 'delAddrTime', 'ddpTime', 'examOnTime', 'examOffTime', 'fltNo');
    }

    getDbMappings(jobName:string):IDictionary<DBMappingInfo> {
        return MblStatusViewModel.getFieldMappings(jobName);
    }

    static _aimDicFieldMappings:IDictionary<DBMappingInfo> = {
        'commDocBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'commDocDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'commDocChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f7501By': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f7501Date': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f7501Chk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f3461By': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f3461Date': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'f3461Chk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'puSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'puSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'puSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delActBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delActDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'delActChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'podBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'podDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'podChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billPacketBy': new DBMappingInfo({ field: 'F_C10', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billPacketDate': new DBMappingInfo({ field: 'F_D10', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'billPacketChk': new DBMappingInfo({ field: 'F_N10', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 15 }),
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AIMMAIN', tbId: '@TbId', type: 16 }),
        'anSendBy': new DBMappingInfo({ field: 'AnSendBy', table: 'T_AIMMAIN' }),
        'anSend': new DBMappingInfo({ field: 'AnSend', table: 'T_AIMMAIN' }),
        'atmeSendBy': new DBMappingInfo({ field: 'AtmeSendBy', table: 'T_AIMMAIN' }),
        'atmeSend': new DBMappingInfo({ field: 'AtmeSend', table: 'T_AIMMAIN' }),
        'cargoRls': new DBMappingInfo({ field: 'CargoRls', table: 'T_AIMMAIN' }),
        'cargoRlsBy': new DBMappingInfo({ field: 'CargoRlsBy', table: 'T_AIMMAIN' }),
        'isCargoRls': new DBMappingInfo({ field: 'IsCargoRls', table: 'T_AIMMAIN' }),
    };

    static _aemDicFieldMappings:IDictionary<DBMappingInfo> = {
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'anSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doSentBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doSentDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'doSentChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'delAddrBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'delAddrDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'delAddrChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'ddpBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'ddpDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'ddpChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 16 }),
        'commDocBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'commDocDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'commDocChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'entryDocChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f7501By': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f7501Date': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f7501Chk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f3461By': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f3461Date': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'f3461Chk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'cargoOnBoard': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),
        'delSchedChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TbId', type: 15 }),

    };

    // Called from View to make SQLList by passing arg
    static getFieldMappings = (jobName: string): IDictionary<DBMappingInfo> => {
        const dicFieldMappings: IDictionary<DBMappingInfo> = {};

        if (jobName === JobNames.AIMbl)
            return PimsContainer._airDicFieldMappings;
        else if (jobName === JobNames.AEMbl)
            return this._aemDicFieldMappings;
        else {
            const srcFieldMappings = PimsContainer._seaDicFieldMappings;
            _.keys(srcFieldMappings).forEach(m => {
                dicFieldMappings[`cntrItemList.${m}`] = srcFieldMappings[m];
            });
        }
        return dicFieldMappings;
    };
}

export interface MblStatusMapItem {
    label: string,
    mblProp?: string,
    cntrDate?: string,
    cntrLoc?: string,
    pimsCntrDate?: string,
    pimsCntrLoc?: string,
}

export enum OceanEventName {
    ReceiveAnFromCarr,
    SendAnToCust,
    MblReceive,
    ReceiveCrDb,
    CustomsHold,
    DevanInstToCfs,
    ArrangeTrucking,
    SendPuDelInst,
    SendPod,

    Booking,        // = 'Booking',
    BookingConfirm, 
    ContainerDispatched,    // = 'ContainerDispatched',
    PickupEmptyContainer,   //
    InGate,                 // = 'InGate',
    DeliveryToCarrier,
    LoadedOnVessel,         // = 'LoadedonVessel',
    VesselDeparture,        // = 'VesselDeparture',
    CarrierRelease,         // = 'CarrierRelease',
    CustomsRelease,         // = 'CustomsRelease',
    VesselArrival,          // = 'VesselArrival',
    UnloadedFromVessel,     // = 'UnloadedfromVessel',
    //DevanningInsttoCFS = 'DevanningInsttoCFS',
    RailDeparture,          // = 'RailDeparture',
    RailArrival,            // = 'RailArrival',
    AvailableForDelivery,   // = 'AvailableforDelivery',
    OutGate,                // = 'OutGate',
    DeliverToCustomer,      // = 'DelivertoCustomer',
    ReturnEmptyContainer,   // = 'ReturnEmptyContainer',

    SendSedToCarrier,
    PickupLoadContainer,
    FileAes,
    SendOceanCargoManifest,
    SendAgentDocPackage,
    OeArrangeTrucking,
    OeBookingConfirm,
    OePickupEmptyContainer,
    OeDeliveryToCarrier,
}

export enum AirEventName {
    PickUp,
    FlightDepature,
    CustomsRelease,
    FlightArrival,
    AvailableForDelivery,
    DeliveryCustomer,
}

/**
 * 16 events
 */
export const OiContainerEvents = [
    OceanEventName.Booking,
    OceanEventName.ContainerDispatched,
    OceanEventName.InGate,
    OceanEventName.LoadedOnVessel,
    OceanEventName.VesselDeparture,
    OceanEventName.CarrierRelease,
    OceanEventName.CustomsRelease,
    OceanEventName.VesselArrival,
    OceanEventName.UnloadedFromVessel,
    OceanEventName.DevanInstToCfs,
    OceanEventName.RailDeparture,
    OceanEventName.RailArrival,
    OceanEventName.AvailableForDelivery,
    OceanEventName.OutGate,
    OceanEventName.DeliverToCustomer,
    OceanEventName.ReturnEmptyContainer
];

/**
 * 16 events
 */
export const OeContainerEvents = [
    OceanEventName.Booking,
    OceanEventName.ContainerDispatched,
    OceanEventName.InGate,
    OceanEventName.LoadedOnVessel,
    OceanEventName.VesselDeparture,
    // OceanEventName.CarrierRelease,
    // OceanEventName.CustomsRelease,
    OceanEventName.VesselArrival,
    OceanEventName.UnloadedFromVessel,
    // OceanEventName.DevanInstToCfs,
    // OceanEventName.RailDeparture,
    // OceanEventName.RailArrival,
    OceanEventName.AvailableForDelivery,
    // OceanEventName.OutGate,
    OceanEventName.DeliverToCustomer,
    // OceanEventName.ReturnEmptyContainer,
];

export const AiAirLineEvents = [
    AirEventName.PickUp,
    AirEventName.FlightDepature,
    AirEventName.CustomsRelease,
    AirEventName.FlightArrival,
    AirEventName.AvailableForDelivery,
    AirEventName.DeliveryCustomer,
];


// prop name must be sames as label without space, /, period
export const OceanMblStatusMap = new Map<OceanEventName, MblStatusMapItem>([
    // follow mblProp
    [OceanEventName.ReceiveAnFromCarr, { label: 'Receive Carrier Arrival Notice', mblProp: 'rcvAnFromCarr', }],
    [OceanEventName.SendAnToCust, { label: 'Send Arrival Notice', mblProp: 'sendAnToCust', }],
    [OceanEventName.MblReceive, { label: 'MBL Receive', mblProp: 'oblDate', }],
    [OceanEventName.ReceiveCrDb, { label: 'Receive CrDb', mblProp: 'rcvCrDb'}],
    [OceanEventName.CarrierRelease, { label: "Carrier Release", mblProp: 'rlsDate', cntrDate: 'carrierRls', cntrLoc: 'carrierRlsLoc', pimsCntrDate: 'msCarrierReleased', pimsCntrLoc: 'locCarrierReleased' }],
    [OceanEventName.CustomsHold, { label: "Customs Hold", mblProp: 'customsHold' }],
    [OceanEventName.CustomsRelease, { label: "Customs Release", mblProp: 'customRls', cntrDate: 'customRls', cntrLoc: 'customRlsLoc', pimsCntrDate: 'msCustomsReleased', pimsCntrLoc: 'locCustomsReleased'}],
    [OceanEventName.DevanInstToCfs, { label: 'Devanning Inst. to CFS', mblProp: 'cfsDate', cntrDate: 'cfsDate', cntrLoc: 'cfsDateLoc', pimsCntrDate: 'msDeliveryCFS', pimsCntrLoc: 'locDeliveryCFS'}],
    [OceanEventName.ArrangeTrucking, { label: 'Arrange Trucking', mblProp: 'arrngTruck' }],
    [OceanEventName.SendPuDelInst, { label: 'Send Pickup/Delivery Inst.', mblProp: 'sendPuDelInst'}],
    [OceanEventName.SendPod, { label: 'Send POD to Customer', mblProp: 'sendPod'}],
    [OceanEventName.ReturnEmptyContainer, { label: 'Return Empty Container', mblProp: 'emptyRtnDate', cntrDate: 'emptyReturn', cntrLoc: 'emptyReturnLoc', pimsCntrDate: 'msEmptyCntrRtn', pimsCntrLoc: 'locEmptyCntrRtn'}],

    // Additional container events: follow 
    [OceanEventName.Booking, { label: 'Booking', cntrDate: 'bookingDate', cntrLoc: 'bookingLoc', pimsCntrDate: 'msBooking', pimsCntrLoc: 'locBooking'}],
    [OceanEventName.BookingConfirm, { label: 'Booking Confirm', cntrDate: 'bookingDate', cntrLoc: 'bookingLoc', pimsCntrDate: 'msBooking', pimsCntrLoc: 'locBooking'}],
    [OceanEventName.ContainerDispatched, { label: 'Container Dispatched', cntrDate: 'ord', cntrLoc: 'ordLoc', pimsCntrDate: 'msPickup', pimsCntrLoc: 'locContainerDispatched'}],
    [OceanEventName.PickupEmptyContainer, { label: 'Pickup Empty Container', cntrDate: 'ord', cntrLoc: 'ordLoc', pimsCntrDate: 'msPickup', pimsCntrLoc: 'locContainerDispatched'}],
    [OceanEventName.InGate, { label: 'In Gate', cntrDate: 'inDate', cntrLoc: 'inDateLoc', pimsCntrDate: 'msOriginReceipt', pimsCntrLoc: 'locInGate'}],
    [OceanEventName.DeliveryToCarrier, { label: 'Deliver to Carrier', cntrDate: 'inDate', cntrLoc: 'inDateLoc', pimsCntrDate: 'msOriginReceipt', pimsCntrLoc: 'locInGate'}],
    [OceanEventName.LoadedOnVessel, { label: 'Load on Vessel', cntrDate: 'loadDate', cntrLoc: 'loadDateLoc', pimsCntrDate: 'msLoadedOnVessel', pimsCntrLoc: 'locLoadedOnVessel'}],
    [OceanEventName.VesselDeparture, { label: 'Vessel Departure', cntrDate: 'atd', cntrLoc: 'atdLoc', pimsCntrDate: 'msShipDeparture', pimsCntrLoc: 'locVesselDeparture'}],
    [OceanEventName.VesselArrival, { label: 'Vessel Arrival', cntrDate: 'ata', cntrLoc: 'ataLoc', pimsCntrDate: 'msShipArrival', pimsCntrLoc: 'locVesselArrival'}],
    [OceanEventName.UnloadedFromVessel, { label: 'Unload from Vessel', cntrDate: 'unloadDate', cntrLoc: 'unloadDateLoc', pimsCntrDate: 'msUpLoadedFromVessel', pimsCntrLoc: 'locUpLoadedFromVessel'}],
    [OceanEventName.RailDeparture, { label: 'Rail Departure', cntrDate: 'rAtd', cntrLoc: 'rAtdLoc', pimsCntrDate: 'msRailDeparture', pimsCntrLoc: 'locRailDeparture'}],
    [OceanEventName.RailArrival, { label: 'Rail Arrival', cntrDate: 'rAta', cntrLoc: 'rAtaLoc', pimsCntrDate: 'msRailArrival', pimsCntrLoc: 'locRailArrival'}],
    [OceanEventName.AvailableForDelivery, { label:"Available for Delivery", cntrDate: 'puDate', cntrLoc: 'puDateLoc', pimsCntrDate: 'msAvailablePickup', pimsCntrLoc: 'locAvailablePickup'}],
    [OceanEventName.OutGate, { label: 'Out Gate', cntrDate: 'outDate', cntrLoc: 'outDateLoc', pimsCntrDate: 'msPickupDelivery', pimsCntrLoc: 'locOutGate'}],
    [OceanEventName.DeliverToCustomer, { label: 'Deliver to Customer', cntrDate: 'dcDate', cntrLoc: 'dcDateLoc', pimsCntrDate: 'msDeliveryCustomer', pimsCntrLoc: 'locDeliveryCustomer'}],

    // OceanExport
    [OceanEventName.OeBookingConfirm, { label: 'Booking Confirm', mblProp: 'bookCfrm'}],
    [OceanEventName.OeArrangeTrucking, { label: 'Arrange Trucking', mblProp: 'arrangeTruck' }],
    [OceanEventName.SendSedToCarrier, { label: 'Send SED to Carrier', mblProp: 'sedSent'}],
    [OceanEventName.PickupLoadContainer, { label: 'Pickup Load Container', mblProp: 'loadPickup'}],
    [OceanEventName.FileAes, { label: 'File AES', mblProp: 'aesFile'}],
    [OceanEventName.SendOceanCargoManifest, { label: 'Send Ocean Cargo Manifest', mblProp: 'sendManifest'}],
    [OceanEventName.SendAgentDocPackage, { label: 'Send Agent\'s Doc Package', mblProp: 'sendAgtDoc'}],
    [OceanEventName.OePickupEmptyContainer, { label: 'Pickup Empty Container', mblProp: 'emptyPickup'}],
    [OceanEventName.OeDeliveryToCarrier, { label: 'Deliver to Carrier', mblProp: 'dlvrToCarr'}],

]);

export const AirMblStatusMap = new Map<AirEventName, MblStatusMapItem>([
    [AirEventName.PickUp, { label: 'Pickup', cntrDate: 'PickupDate', cntrLoc: 'PickupLoc', pimsCntrDate: 'msPickup', pimsCntrLoc: 'locContainerDispatched'}],
    [AirEventName.FlightDepature, { label: 'Flight Departure', cntrDate: 'Atd', cntrLoc: 'AtdLoc', pimsCntrDate: 'msShipDeparture', pimsCntrLoc: 'locVesselDeparture'}],
    [AirEventName.CustomsRelease, { label: "Customs Release", mblProp: 'customRls', cntrDate: 'CustomsRls', cntrLoc: 'CustomsRlsLoc', pimsCntrDate: 'msCustomsReleased', pimsCntrLoc: 'locCustomsReleased'}],
    [AirEventName.FlightArrival, { label: 'Flight Arrival', cntrDate: 'Ata', cntrLoc: 'AtaLoc', pimsCntrDate: 'msShipArrival', pimsCntrLoc: 'locVesselArrival'}],
    [AirEventName.AvailableForDelivery, { label:"Available for Delivery", cntrDate: 'Avail', cntrLoc: 'AvailLoc', pimsCntrDate: 'msAvailablePickup', pimsCntrLoc: 'locAvailablePickup'}],
    [AirEventName.DeliveryCustomer, { label: 'Delivery to Customer', cntrDate: 'Delivery', cntrLoc: 'DelvLoc', pimsCntrDate: 'msDeliveryCustomer', pimsCntrLoc: 'locDeliveryCustomer'}],
]);